import { AuthSettings } from './types'

const localStorageAuthKey = 'authSession'

export type Session = {
    userId: string
    idToken: string
    accessToken: string
    refreshToken?: string
    tokenExpiration?: Date | string
}

export const loadSession = (authSettings: AuthSettings): Session | null => {
    const value = localStorage.getItem(`${localStorageAuthKey}:${authSettings.clientId}`)
    if (value) {
        try {
            return JSON.parse(value)
        } catch (e) {
            // --
        }
    }

    return null
}

export const storeSession = (authSettings: AuthSettings, session: Session) => {
    localStorage.setItem(`${localStorageAuthKey}:${authSettings.clientId}`, JSON.stringify(session))
}

export const clearSession = (authSettings: AuthSettings) => {
    localStorage.removeItem(`${localStorageAuthKey}:${authSettings.clientId}`)
}
